import { atom } from '@reatom/framework'
import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'

import {
  openCancelLimitOrderDrawerEvent,
  openEditLimitOrderDrawerEvent,
} from '@root/features/trade/limit-orders'

import { CloseOrderDrawer } from './close-order-drawer'
import { EditOrderDrawer } from './edit-order-drawer'

import type { LimitOrderModel } from '@root/entities/limit-order'
import type { LimitOrderId } from '@root/entities/limit-order/model/limit-order-id'

type EditOrderDrawerControllerProps = {}

const editingOrderAtom = atom<LimitOrderModel | undefined>(
  undefined,
  'editingOrderAtom',
)

openEditLimitOrderDrawerEvent.onCall((ctx, _, [{ order }]) => {
  editingOrderAtom(ctx, order)
})

const cancelingOrderAtom = atom<{ orderId: LimitOrderId } | undefined>(
  undefined,
  'cancelingOrderAtom',
)

openCancelLimitOrderDrawerEvent.onCall((ctx, _, [{ orderId }]) => {
  cancelingOrderAtom(ctx, { orderId })
})

export const EditOrderDrawerController: React.FC<
  EditOrderDrawerControllerProps
> = () => {
  const [order, setOrder] = useAtom(editingOrderAtom)
  const [orderToCancel, setOrderToCancel] = useAtom(cancelingOrderAtom)

  return (
    <>
      {
        <AnimatePresence>
          {order ? (
            <EditOrderDrawer
              open
              order={order}
              onOpenChange={(open) => {
                if (!open) {
                  setOrder(undefined)
                }
              }}
            />
          ) : undefined}
        </AnimatePresence>
      }
      {
        <AnimatePresence>
          {orderToCancel ? (
            <CloseOrderDrawer
              open
              orderId={orderToCancel.orderId}
              onOpenChange={(open) => {
                if (!open) {
                  setOrderToCancel(undefined)
                }
              }}
            />
          ) : undefined}
        </AnimatePresence>
      }
    </>
  )
}
